import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  TableCell
} from "@material-ui/core";
import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const PrimaryButton = styled(Button)`
  && {
    background: #2196f3;
    color: white;
    font-size: 17px;
    padding: 0px 12px;
    height: auto;
  }
`;

const HeightSetDialogContent = styled(DialogContent)`
  && {
    height: 400px;
    width: 380px;
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  font-size: 22;
`;

const WrappingCheckboxWithLabel = styled(FormControlLabel)`
  margin-top: 25px;
  && span {
    max-width=100%;
    white-space: normal;
    font-size: 17px;
  }
`;

export class InviteToItemsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
      isOpen: props.isOpen
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        selectedItems: [],
        isOpen: true
      };
    }
    if (!props.isOpen && state.isOpen) {
      return {
        isOpen: false
      };
    }

    return null;
  }

  toggleItemSelection = item => () => {
    const { selectedItems } = this.state;
    const currentIndex = selectedItems.indexOf(item);
    const newSelectedItems = [...selectedItems];

    if (currentIndex === -1) {
      newSelectedItems.push(item);
    } else {
      newSelectedItems.splice(currentIndex, 1);
    }

    this.setState({
      selectedItems: newSelectedItems
    });
  };

  itemsTableColumns = [
    {
      id: "itemName",
      label: "Name",
      isString: true,
      isBaseColumn: true,
      searchable: true,
      dataField: "name"
    },
    {
      id: "add",
      label: "Invite",
      actions: true,
      align: "center",
      cell: row => (
        <TableCell>
          <div style={{ textAlign: "center" }}>
            <Checkbox
              disabled={row.disabled}
              checked={this.state.selectedItems.indexOf(row.data) !== -1}
              onClick={this.toggleItemSelection(row.data)}
            />
          </div>
        </TableCell>
      )
    }
  ];

  handleSelectedItemsChanged = selectedItems => {
    this.setState({ selectedItems });
  };

  render() {
    return (
      <Dialog
        id="InviteToItemsModal"
        open={this.props.isOpen}
        onClose={this.props.onClose}
        aria-labelledby="InviteToItemsModalTitle"
      >
        <DialogTitle id="InviteToItemsModalTitle">
          Invite to {this.props.itemName}s
          <StyledDialogIconButton onClick={this.props.onClose}>
            <StyledCloseIcon id="closeIcon" />
          </StyledDialogIconButton>
        </DialogTitle>
        <HeightSetDialogContent>
          <EnhancedTable
            columnDefinitions={this.itemsTableColumns}
            rows={this.props.items}
            sortable={false}
            orderBy={this.itemsTableColumns[0]}
            shouldHideConfig
            shouldHideExport
            searchHintText="Search by Item"
            searchable
            maxHeight={280}
            disabled={this.state.addToAllItems}
          />
          {/* <WrappingCheckboxWithLabel
            label={this.props.addToAllItemsLabel}
            control={
              <Checkbox
                checked={this.state.addToAllItems}
                onChange={() => this.setState({ addToAllItems: !this.state.addToAllItems })}
              />
            }
          /> */}
        </HeightSetDialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <PrimaryButton
            size="medium"
            onClick={() => {
              if (this.state.addToAllItems) {
                this.props.onAddToAllItems();
              } else {
                this.props.onAddItems(this.state.selectedItems);
              }
              this.props.onClose();
            }}
          >
            Send Invite
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

InviteToItemsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddItems: PropTypes.func.isRequired,
  onAddToAllItems: PropTypes.func.isRequired,
  addToAllItemsLabel: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  itemName: PropTypes.string.isRequired
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(InviteToItemsModal);
